import { getAuth } from 'firebase/auth';

class ApiService {
    constructor(baseUrl) {
        this.baseUrl = baseUrl;
        this.auth = getAuth();
    }

    async _getAuthToken() {
        try {
            const currentUser = this.auth.currentUser;
            if (!currentUser) {
                throw new Error('User is not authenticated');
            }
            return await currentUser.getIdToken();
        } catch (error) {
            console.error('Failed to get auth token:', error);
            throw error;
        }
    }

    // POST request
    async post(endpoint, data) {
        try {
            const idToken = await this._getAuthToken();
            
            const response = await fetch(`${this.baseUrl}${endpoint}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${idToken}`,
                },
                // credentials: 'include',
                body: JSON.stringify(data),
            });

            if (!response.ok) {
                let errorData;
                try {
                    errorData = await response.json();
                } catch (e) {
                    errorData = { message: await response.text() };
                }
                throw new Error(errorData.message || `Error ${response.status}: ${response.statusText}`);
            }

            return await response.json();
        } catch (error) {
            console.error('POST request failed:', error);
            throw error;
        }
    }

    // GET request
    async get(endpoint) {
        try {
            const idToken = await this._getAuthToken();
            
            const response = await fetch(`${this.baseUrl}${endpoint}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${idToken}`,
                },
                // credentials: 'include',
            });

            if (!response.ok) {
                let errorData;
                try {
                    errorData = await response.json();
                } catch (e) {
                    errorData = { message: await response.text() };
                }
                throw new Error(errorData.message || `Error ${response.status}: ${response.statusText}`);
            }

            return await response.json();
        } catch (error) {
            console.error('GET request failed:', error);
            throw error;
        }
    }
}

// Export only the class, not an instance
export default ApiService;
